import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LANGUAGES } from '../../constants';
import * as commonActions from '../../actions/common';

class LanguageSelect extends React.Component {
	handleChangeLanguage(event) {
		LANGUAGES.forEach(function(language){
			if (language.name === event.target.value) {
				this.props.changeLanguageAction(language);
			}
		}, this);
	}
	
	render() {
		var options = [];
		LANGUAGES.forEach(function(language) {
			var option = (
				<option value={language.name} key={language.country}>
					{language.name}
				</option>
			);
			options.push(option);
		});
		return (
			<label className="msidebar-lang">
				<select className="msidebar-lang__select" id="J-lang-select" value={this.props.language.name} onChange={this.handleChangeLanguage.bind(this)}>
					{options}
				</select>
			</label>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		language: state.data.language
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, commonActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect);


// WEBPACK FOOTER //
// ./app/components/mobile/LanguageSelect.js